import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { Layout, Position, Tab } from '@shell/types/window-manager';
import { CSS_KEY } from '../constants';

export default (props?: { positions: Position[], layout: Layout }) => {
  const store = useStore();

  const isPanelEnabled = computed(() => (props?.positions || []).reduce((acc, pos) => ({
    ...acc,
    [pos]: store.state.wm.open[pos] && store.state.wm.tabs.some((t: Tab) => t.position === pos) && !store.state.wm.tabs.find((t: Tab) => !t.layouts.includes(props?.layout || Layout.default) && t.position === pos),
  }), {} as Record<Position, boolean>));

  // Dimensions are global CSS variables, so a disabled panel must release its
  // grid track even when no panel component exists to run unmount cleanup.
  watch(isPanelEnabled, (enabled) => {
    Object.entries(CSS_KEY).forEach(([position, key]) => {
      if (!enabled[position as Position]) {
        document.documentElement.style.setProperty(key, '0px');
      }
    });
  }, { immediate: true });

  return { isPanelEnabled };
};
